import TabContainer from "components/foundation/TabContainer/TabContainerPage";

const ShoppingCartPage = () => {
  const subMenu = [
    {
      name: "Chọn giữ số",
      path: "/number-cart-page",
      componentName: "NumberCartPage",
      code: "numberCartPage",
    },
    {
      name: "Đơn hàng số đẹp",
      path: "/pemium-number-cart-page",
      componentName: "PremiumNumberCartPage",
      code: "premiumNumberCartPage",
    },
  ];

  return (
    <>
      <TabContainer centered={true} subMenu={subMenu} />
    </>
  );
};

export default ShoppingCartPage;
